import React from 'react';
import { Form, Row, Col, Button, Modal, Spin, message } from 'antd';
import { HJCreateReceiver } from '@FORMS';
import { createReceiver } from '@RECEIVERS';
import { AiFillSave } from 'react-icons/ai';

const CreateReceiverModal = ({ form, onClose, setStep, setSpin, spin }) => {
  const [modal, contextHolder] = Modal.useModal();
  const handleSave = async (values) => {
    setSpin(true);
    let obj = {
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone.replace(/ /g, ''),
      address: {
        city: values.recipientCity,
        town: values.recipientTown,
        district: values.recipientDistrict,
        addressLine: values.recipientAddressLine,
      },
    };
    const response = await createReceiver(obj);
    setSpin(false);
    if (response.id) {
      message.success({
        content: 'Kişi başarıyla eklendi',
        className: 'app-success-message',
      });
      form.resetFields();
      setStep('TABLE');
    } else if (
      response?.response?.data?.error?.msg?.includes(
        'daha önceden kişi tanımlanmış.'
      )
    ) {
      modal.confirm({
        title: response?.response?.data?.error?.msg,
        content: 'Tekrar kayıt oluşturulsun mu?',
        icon: <AiFillSave />,
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: () => {
          forceSave(obj);
        },
        onCancel: () => form.resetFields(),
      });
    } else {
      message.error({
        content: response?.response?.data?.error?.msg,
        className: 'app-error-message',
      });
    }
  };
  const forceSave = async (values) => {
    let obj = values;
    obj.force = true;
    const response = await createReceiver(obj);
    if (response.id) {
      message.success({
        content: 'Kişi başarıyla eklendi',
        className: 'app-success-message',
      });
      form.resetFields();
      setStep('TABLE');
    } else {
      message.error({
        content: response?.response?.data?.error?.msg,
        className: 'app-error-message',
      });
    }
  };

  return (
    <Modal
      visible
      title="Kişi Kaydet"
      onCancel={onClose}
      width={1350}
      footer={false}
    >
      {contextHolder}
      <Form form={form} layout="vertical">
        <HJCreateReceiver form={form} />

        <Row gutter={24}>
          <Col flex={'auto'}>
            <Spin spinning={spin} />
          </Col>
          <Col flex="auto">
            <Button
              style={{ float: 'right' }}
              type="danger"
              onClick={() => {
                setStep('TABLE');
                form.resetFields();
              }}
              icon={<AiFillSave />}
            >
              Vazgeç
            </Button>
          </Col>
          <Col flex="none">
            <Button
              style={{ float: 'right' }}
              type="primary"
              onClick={() => {
                form.validateFields().then((values) => {
                  handleSave(values);
                });
              }}
              icon={<AiFillSave />}
            >
              Kişiyi Kaydet
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CreateReceiverModal;
